<template>
  <InputComponent v-bind="$attrs">
    <template #default>
      <textarea
        v-model="valueComp"
        :rows="$attrs.rows || 2"
        class="elder-input__element"
        style="resize: vertical"
        :placeholder="$attrs.placeholder"
      ></textarea>
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: String,
  },
  computed: {
    valueComp: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  components: {
    InputComponent,
  },
}
</script>
